import { render, staticRenderFns } from "./ParentFicheContrat.vue?vue&type=template&id=3bb85e3e&"
import script from "./ParentFicheContrat.vue?vue&type=script&lang=js&"
export * from "./ParentFicheContrat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports